module.exports = __webpack_public_path__ + "img/playstore.e834f604.svg";